import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Table, Spinner, UncontrolledCarousel, Button, ListGroup, ListGroupItem, Label, Input, FormGroup, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Cropper from 'react-cropper';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

import ExpandableItem, { Detail } from '../../components/ExpandableItem';
import Confirm from '../../components/Confirm';
import Prompt from '../../components/Prompt';
import ShareButton from '../../components/ShareButton/index';

import 'cropperjs/dist/cropper.css';

import '../../components/ShareButton/ShareBtn.css';

import actions from './actions';

const formatBytes = (value, decimals = 2) => {
  if (value === 0) return '0 B';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(value) / Math.log(k));

  return parseFloat((value / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];  
}

class ListaAchadosPerdidos extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openDetail: null,
      prompt: {
        modalProps: {
          headerText: "Devolução"
        },
        open: false
      },
      confirm: {
        open: false,
      },
      cropImage: {
        open: false,
      },
      addItem: {
        open: false,
        value: {
          nome: '',
          local: '',
          observacao: '',
          arquivos: []
        }
      },
      viewPicture: {
        open: false,
        value: {}
      },
    }
  }

  componentDidMount () {
    let { actions, selected } = this.props;
    actions.onLoadItems().then(value => {
      if (selected) {
        if (!value.result.some(v => {
          if (parseInt(selected, 10) === v.id) {
            this.toggleModal('viewPicture', { value: v });
            return true;
          }
          return false;
        })) {
          this.openConfirmation('Item indisponível.');
        }
      }
    });
  }

  static getDerivedStateFromProps(props, state) {
    const { viewPicture } = state;
    if (viewPicture.open) {
      const value = props.value.result.find(v => v.id === viewPicture.value.id);
      if (value && viewPicture.value !== value) {
        return {
          viewPicture: {
            ...state.viewPicture,
            value
          }
        };
      }
    }
    return null;
  }

  toggleModal = (name, value) => new Promise(resolve => {
    this.setState(state => ({
      [name]: {
        ...state[name],
        open: !state[name].open,
        ...value
      }
    }), resolve);
  });

  togglePicture = (value = {}) => e => {
    e.preventDefault();
    e.stopPropagation();

    this.toggleModal('viewPicture', { value });
  }

  toggleAddItem = e => this.toggleModal('addItem', {
    value: {
      nome: '',
      local: '',
      observacao: '',
      arquivos: []
    }
  });

  toggleCropImage = e => {
    URL.revokeObjectURL(this.state.cropImage.modified);
    this.toggleModal('cropImage', { modified: null });
  }

  addItem = tipo => e => this.toggleModal('addItem', { tipo });

  isFirstItem = () => 0 === this.props.value.result.indexOf(this.state.viewPicture.value);

  previousItem = e => this.setState(({ viewPicture }) => ({
    viewPicture: {
      ...viewPicture,
      value: this.props.value.result.find((_v, i, a) => viewPicture.value === a[i + 1])
    }
  }));

  nextItem = e => this.setState(({ viewPicture }) => ({
    viewPicture: {
      ...viewPicture,
      value: this.props.value.result.find((_v, i, a) => i && viewPicture.value === a[i - 1])
    }
  }));

  isLastItem = () => this.props.value.result.length - 1 === this.props.value.result.indexOf(this.state.viewPicture.value);

  handleChange = field => e => {
    const value = e.target.value.replace(/^\s+|\s+(?=\s$|\s)/g, '');

    this.setState(state => ({
      addItem: {
        ...state.addItem,
        value: {
          ...state.addItem.value,
          [field]: value
        }
      }
    }));
  };

  handleAddItemConfirmation = e => {
    e.preventDefault();
    e.stopPropagation();

    const { addItem: { value, tipo }, cropImage: { original } } = this.state;

    const files = [...value.arquivos];
    let add = false;
    if (!files.length && original) {
      files.push(original);
      add = true;
    }

    if (files.some((v, i) => i > 2 || v.size > 2 * Math.pow(1024, 2))) {
      alert("Apenas 3 arquivos de 2 MB cada são permitidos.");
      return;
    } else if (add) {
      value.arquivos.push(original);
    }

    this.props.actions.adicionaItem({ value, tipo })
    .then(() => this.toggleAddItem(e))
    .then(() => this.props.actions.onLoadItemsIfNeeded());

    return false;
  };

  handleNewImage = e => {
    const original = e.target.files[0];

    URL.revokeObjectURL(this.state.cropImage.modified);
    this.toggleModal('cropImage', {
      original,
      modified: URL.createObjectURL(original)
    });
  };

  addImage = e => {
    const original = this.state.cropImage.original;
    this.refs.imageCropper.getCroppedCanvas({
      maxWidth: "100%",
      maxHeight: "100%"
    }).toBlob(blob => {
      URL.revokeObjectURL(this.state.cropImage.modified);
      this.setState(state => ({
        cropImage: {
          open: false
        },
        addItem: {
          ...state.addItem,
          value: {
            ...state.addItem.value,
            arquivos: state.addItem.value.arquivos.concat(new File([blob], original.name, {
              type: original.type,
              lastModified: new Date()
            }))
          }
        }
      }));
    }, original.type, 0.7);
  };

  removeImage = index => e => {
    this.setState(state => ({
      addItem: {
        ...state.addItem,
        value: {
          ...state.addItem.value,
          arquivos: state.addItem.value.arquivos.filter((_v, i) => i !== index)
        }
      }
    }));
  };

  handleConfirm = () => {
    this.toggleModal('confirm').then(() => this.handleAtualizacao());
  };

  openConfirmation = (value, cb = () => {}) => {
    this.handleAtualizacao = cb;
    this.toggleModal('confirm', {value});
  };

  handlePrompt = value => {
    this.toggleModal('prompt').then(() => this.handleAtualizacao(value));
  };

  openPrompt = (value, cb = () => {}, otherProps) => {
    this.handleAtualizacao = cb;
    this.toggleModal('prompt', { ...otherProps, value });
  };

  flagItem = e => {
    this.openPrompt("Informe o motivo:", observacao => {
      this.props.actions.denunciaItem({ value: this.state.viewPicture.value, observacao });
    }, {
      modalProps: {
        headerText: "Denúncia"
      }
    });
  };

  handleDevolver = e => {
    this.openPrompt("Informe a quem foi entregue:", observacao => {
      this.props.actions.atualizaSituacao({ value: this.state.viewPicture.value, observacao });
    }, {
      modalProps: {
        headerText: "Devolução"
      }
    });
  };

  handleEstaComigo = e => {
    this.props.actions.atualizaPessoa({ value: this.state.viewPicture.value, devolvido: 0 });
  };

  validatePrompt = value => !!value && 5 < value.trim().length;

  handleMeu = e => {
    const { aviso } = this.state.viewPicture.value;
    if (aviso) {
      this.openConfirmation(<div>O item já foi reinvidicado por XXX.<br />Caso o item seja seu, reinvindique-o na portaria.</div>);
    } else {
      this.props.actions.atualizaPessoa({ value: this.state.viewPicture.value, devolvido: 1 });
    }
  };

  onLoadExpansion = v => isOpen => {
    if (isOpen) {
      return this.props.actions.onLoadHistorico(v).then(() => {
        this.setState({
          openDetail: v.id
        });
      });
    } else {
      this.setState({
        openDetail: null
      });
    }

    return Promise.resolve();
  };

  render () {
    const { viewPicture, addItem, cropImage, confirm, prompt } = this.state;
    const { value: { result, fetching, updated_at }, actions, t } = this.props;

    return (
      <Fragment>
      <ListGroup>
        {result.map((v, i) => (<ExpandableItem
          async
          onExpand={this.onLoadExpansion(v)}
          key={i}
          tag={ListGroupItem}
          color={3 === v.tipo?"success":(2 === v.tipo?"warning":"danger")}
          className="d-flex justify-content-between align-items-center">
          <span>{v.nome}<br /></span>
          <div className="text-right">
            <Button onClick={this.togglePicture(v)}><span className="fa fa-image"></span> <span className="d-none d-sm-inline-block">Foto</span></Button>
          </div>
          <Detail>
            {v.historico && <Table striped responsive size="sm">
              <thead>
                <tr>
                  <th className="d-xs-table-cell d-md-none">Data & Situação</th>
                  <th className="d-none d-md-table-cell">Data</th>
                  <th className="d-none d-md-table-cell">Usuário</th>
                  <th className="d-none d-md-table-cell">Situação</th>
                  <th>Observação</th>
                </tr>
              </thead>
              <tbody>
                {v.historico.map((v, i) => (<tr key={i}>
                  <td className="d-xs-table-cell d-md-none">{moment(v.created_at).format("DD/MM/YYYY HH:mm")}<br />{t(["achadosPerdidos:historico.situacoes." + v.situacao_anterior + "_" + v.situacao_atual + "_" + v.mesmo_usuario])}</td>
                  <td className="d-none d-md-table-cell">{moment(v.created_at).format("DD/MM/YYYY HH:mm")}</td>
                  <td className="d-none d-md-table-cell">{v.nome_usuario}</td>
                  <td className="d-none d-md-table-cell">{t(["achadosPerdidos:historico.situacoes." + v.situacao_anterior + "_" + v.situacao_atual + "_" + v.mesmo_usuario])}</td>
                  <td>{v.observacao}</td>
                </tr>))}
              </tbody>
            </Table>}
          </Detail>
        </ExpandableItem>))}
        <ListGroupItem className="d-flex justify-content-around">
          <Button color="danger" onClick={this.addItem(1)}><span className="fa fa-thumbs-down"></span> Perdi algo...</Button>
          <Button color="success" onClick={this.addItem(2)}><span className="fa fa-thumbs-up"></span> Achei algo...</Button>
          <Button color="link" size="sm" onClick={actions.onLoadItemsIfNeeded} title="Recarregar"><span className={"fa fa-sync" + (1 === fetching?" fa-spin":"")} /></Button>
        </ListGroupItem>
        {1 === fetching && (
          <ListGroupItem color="dark">
            <Spinner size="sm" color="dark" /> Obtendo lista de itens...
          </ListGroupItem>
        )}
        {2 === fetching && !result.length && (
          <ListGroupItem color="success">
            Não há itens achados ou perdidos.
          </ListGroupItem>
        )}
        {2 === fetching && 0 < result.length && (
          <ListGroupItem
            color="info"
          >
            Atualizado em{' '}
            {moment(updated_at).format('DD/MM/YYYY HH:mm')}
          </ListGroupItem>
        )}
      </ListGroup>
      <Modal size="lg" isOpen={viewPicture.open} toggle={this.togglePicture()} scrollable>
        <ModalHeader className="d-sm-none d-md-flex" toggle={this.togglePicture()}>
        {viewPicture.value.nome}
        </ModalHeader>
        <ModalBody className="d-sm-none d-md-block" style={{minHeight: "55px", maxHeight: "55px", paddingBottom:0, paddingTop:0}}>
        <sub>
          {viewPicture.value.local}<br />
          {viewPicture.value.usuario_atual}
        </sub>
        </ModalBody>
        <ModalBody className="d-flex justify-content-between align-items-start" style={{minHeight: "62px", maxHeight: "62px", paddingTop:"0.5rem", paddingBottom: "1rem"}}>
          <div>
            <Button color="danger" onClick={this.flagItem}><span className="fa fa-flag"></span></Button>{' '}
            <ShareButton tag={Button} className="d-inline-block" buttonProps={{color:"info"}} url={window.location.origin + "/achados/" + viewPicture.value.id + "-" + (viewPicture.value.nome||"").toLowerCase().replace(/\s+/g, "-")} displayText="" text={"Achados & Perdidos » " + viewPicture.value.nome}><span className="fa fa-share-alt-square"></span></ShareButton>
          </div>
          {1 === viewPicture.value.acao_principal && <Button disabled={1 === fetching} color="success" onClick={this.handleMeu}><span className="fa fa-thumbs-up"></span> Achei!</Button>}
          {2 === viewPicture.value.acao_principal && <Button disabled={1 === fetching} color="warning" onClick={this.handleDevolver}><span className="fa fa-handshake"></span> Devolvido!</Button>}
          {3 === viewPicture.value.acao_principal && <Button disabled={1 === fetching} color="success" onClick={this.handleMeu}><span className="fa fa-thumbs-up"></span> É meu!</Button>}
          {4 === viewPicture.value.acao_principal && <Button disabled={1 === fetching} color="success" onClick={this.handleEstaComigo}><span className="fa fa-handshake d-none d-sm-inline-block"></span> Está comigo!</Button>}
          <div>
            <Button onClick={this.previousItem} disabled={this.isFirstItem()}><span className="fa fa-arrow-left"></span></Button>{' '}
            <Button onClick={this.nextItem} disabled={this.isLastItem()}><span className="fa fa-arrow-right"></span></Button>
          </div>
        </ModalBody>
        {!viewPicture.value.imagens && !!viewPicture.value.observacao && <ModalBody style={{paddingTop:0}}>
          {viewPicture.value.observacao}
        </ModalBody>}
        {!!viewPicture.value.imagens && <ModalBody style={{paddingTop:0}}>
          <UncontrolledCarousel controls={1 < viewPicture.value.imagens} autoPlay={false} items={[...Array(viewPicture.value.imagens).keys()].map(x => ({
            src: process.env.REACT_APP_BASE_URL_API.replace(
              /\$(\w+)/g,
              (_$0, $1) => window.location[$1]
            ) + "imagem.php?tipo=achados&id=" + viewPicture.value.id + "&index=" + x,
            altText: viewPicture.value.nome,
            caption: viewPicture.value.local,
            header: viewPicture.value.nome
          }))} />
        </ModalBody>}
      </Modal>
      <Modal backdrop="static" isOpen={addItem.open} toggle={this.toggleAddItem}>
        <form onSubmit={this.handleAddItemConfirmation}>
          <input type="hidden" name="MAX_FILE_SIZE" value="2097152" />
          <ModalHeader toggle={this.toggleAddItem}>
            {1 === addItem.tipo?'Perdi algo':'Achei algo'}...
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Nome *</Label>
              <Input required maxLength={40} value={addItem.value.nome} onChange={this.handleChange('nome')} />
            </FormGroup>
            <FormGroup>
              <Label>Local *</Label>
              <Input required maxLength={40} value={addItem.value.local} onChange={this.handleChange('local')} />
            </FormGroup>
            <FormGroup>
              <Label>Observação *</Label>
              <Input required maxLength={255} type="textarea" value={addItem.value.observacao} onChange={this.handleChange('observacao')} />
            </FormGroup>
            <FormGroup>
              <Label>Foto</Label>
              <Input disabled={3 <= addItem.value.arquivos.length} accept="image/*" type="file" onChange={this.handleNewImage} />
              <ul>
                {addItem.value.arquivos.map((v, i) => (<li key={i}><Button outline size="sm" color="danger" onClick={this.removeImage(i)}><span className="fa fa-times"></span></Button> {v.name} - {formatBytes(v.size)}</li>))}
              </ul>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="success">Cadastrar</Button>
          </ModalFooter>
        </form>
      </Modal>
      <Modal size="lg" isOpen={cropImage.open} toggle={this.toggleCropImage} backdrop="static">
        <ModalBody>
          <Cropper
          ref="imageCropper"
          src={cropImage.modified}
          style={{maxHeight:'calc(100vh - 10.5rem)'}}
           />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between align-items-center">
          <Button color="danger" onClick={this.toggleCropImage}>Fechar</Button>
          <Button color="success" onClick={this.addImage}>Confirmar</Button>
        </ModalFooter>
      </Modal>
      <Confirm isOpen={confirm.open} onConfirm={this.handleConfirm}>{confirm.value}</Confirm>
      <Prompt {...prompt.modalProps} inputProps={{required: true}} valid={this.validatePrompt} toggle={() => this.toggleModal('prompt')} isOpen={prompt.open} onConfirm={this.handlePrompt}>{prompt.value}</Prompt>
      </Fragment>
    );
  }
}

let mapStateToProps = ({ achados }) => ({
  value: achados
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ListaAchadosPerdidos));



// WEBPACK FOOTER //
// ./src/modules/achados/ListaAchadosPerdidos.js